<template>
    <div id="bene-aud-bt-receiver-type-container">
        <f7-list form class="form-group" v-if="showFormInput.kaasiDetails.radioButton">
            <f7-block-title class="item-title item-label">{{$t('beneficiary-beneficiary-type')}}</f7-block-title>
            <f7-list-item radio
                input-id     ="radioReceiverTypeInd"
                name         ="radioReceiverType"
                value        ="1"
                :title       ="$t('general-text-individual')"
                :checked     ="beneficiaryTypeId == 1"
                @click       ="changeBeneficiaryType($event.currentTarget.childNodes[0].value); validateInput($event.currentTarget); setInput($event.currentTarget)"
            ></f7-list-item>

            <f7-list-item radio
                input-id     ="radioReceiverTypeBus"
                name         ="radioReceiverType"
                value        ="2"
                :title       ="$t('general-text-business')"
                :checked     ="beneficiaryTypeId == 2"
                @click       ="changeBeneficiaryType($event.currentTarget.childNodes[0].value); validateInput($event.currentTarget); setInput($event.currentTarget)"
            >
                <div slot="root-end" class="mt-sm error-message" v-show="isDisplayErrorMsg">{{radioErrorMsg}}</div>
            </f7-list-item>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'beneficiaryTypeId',
                'isDisplayErrorMsg',
                'radioErrorMsg',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
            ]),

            changeBeneficiaryType(id){
                this.$emit("changeBeneficiaryType", id);
            },

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>